<template>
  <div class="lottery-page">
    <div class="hero-wrap" id="top">
      <HeroCarousel :slides="heroSlides" />
      <span v-if="siteDomain" class="hero-domain">{{ siteDomain }}</span>
    </div>
    <div id="nav2" class="nav2" data-fixed="">
      <ul @click="onNavClick">
        <li><a href="#ampm">跑狗图</a></li>
        <li><a href="#wlrt">网络热图</a></li>
        <li><a href="#sqbk">三期必开</a></li>
        <li><a href="#gsb">高手热榜</a></li>
        <li><a href="#18mzt">18码中特</a></li>
        <li><a href="#ptsx">平特三肖</a></li>

        <li><a href="#wc8x">无错⑧肖</a></li>
        <li><a href="#hszt">合数中特</a></li>
        <li><a href="#yyjx">预言九肖</a></li>
        <li><a href="#qqsh">琴棋书画</a></li>
        <li><a href="#30ma">无错30码</a></li>
        <li><a href="#gsjy">公式家野</a></li>
        <li><a href="#wx16ma">5肖16码</a></li>
        <li><a href="#5xtm">五肖五码</a></li>
        <li><a href="#dslx">单双两肖</a></li>
        <li><a href="#ptyw">平特一尾</a></li>
        <li><a href="#bzyb">必中一波</a></li>
        <li><a href="#js18ma">绝杀18码</a></li>
        <li><a href="#mz14ma">灭庄14码</a></li>
        <li><a href="#jssx">绝杀三肖</a></li>
        <li><a href="#jssx">不买10码</a></li>
        <li><a href="#crcc">吃肉吃菜</a></li>
        <li><a href="#jmxc">吉美凶丑</a></li>
        <li><a href="#yyx">阴阳生肖</a></li>
        <li><a href="#cxqd">春夏秋冬</a></li>
        <li><a href="#top">回到顶部</a></li>
      </ul>
    </div>

    <NoticeBar @domain-loaded="onDomainLoaded" />

    <section class="result-card">
      <div class="game-tabs">
        <button
            v-for="g in games"
            :key="g.id"
            type="button"
            class="game-tabs__btn"
            :class="{ 'is-active': activeId === g.id }"
            @click="activeId = g.id"
        >{{ g.label }}</button>
      </div>

      <div class="result-card__content">
        <div class="result-card__head">
          <h2 class="result-card__title">第 <span style="color: red;">{{ displayResultCardIssue }}</span> 期开奖结果&nbsp;&nbsp;
            <template v-if="current.nextDrawDeadlineMs">
              <strong style="color: red; font-size: 16px;" class="countdown-num">{{ countdownText }}</strong>
            </template>
          </h2>
          <div class="result-card__links">
            <router-link class="link-red" :to="{ path: '/history', query: { game: activeId } }">历史记录</router-link>
          </div>
        </div>

        <div class="result-card__numbers-row">
          <BallDisplay
              :mainNumbers="displayDraw.mainNumbers"
              :special="displayDraw.special"
              :drawPhaseNear="drawPhaseNear"
              :pollSlotRevealed="pollSlotRevealed"
              :drawRevealed="effectiveDrawRevealed"
              :isLiveDrawing="isLiveDrawing"
              :drawingChars="drawingChars"
              :ballTone="ballTone"
          />
        </div>

        <p class="result-card__next" v-if="nextDrawDateText">
          下期开奖: {{ nextDrawDateText }}
        </p>
<!--          <button class="result_card_btn">挑码助手  /</button>-->
      </div>
    </section>
  <div class="box pad"><meta http-equiv="Content-Type" content="text/html; charset=utf-8">

  <table class="table1 fontb dkzlw" style="background:#FFF" width="100%" border="0" cellspacing="0" cellpadding="0" >
    <tbody>
	<tr>
      <th>↓↓↓ 以下网址均可打开<font color="#FF0000">本论坛</font> ↓↓↓</th>
    </tr>
   <tr>
      <td><font color="#FF0000"></font>唯一官网<span class="webblack">{{ siteDomain }}</span></td>
    </tr>
    <tr>
      <td>任意数字或字母组合<span class="webblue">.{{ siteDomain }}</span>访问</td>
    </tr>
    <tr>
      <td><font color="#843fa1">本站启用自定义域名→快捷进站</font></td>
    </tr>
    <tr>
      <td><font color="#e67e23">在网址前任意添加一个或者多个</font></td>
    </tr>
    <tr>
      <td><font color="#ff0000">字母或数字均可打开本论坛（例如以下网址）</font></td>
    </tr>
    <tr>
    <td>启用新网址：<font color="#ec0659"><strong><font color="#ff8c00" size="5px">{{ randomPrefixes[0] }}</font></strong>.{{siteDomain}}&nbsp;&nbsp;截图保存</font></td>
    </tr>
  <tr>
    <td>启用新网址：<font color="#ec0659"><strong><font color="#ff8c00" size="5px">{{ randomPrefixes[1] }}</font></strong>.{{siteDomain}}&nbsp;&nbsp;截图保存</font></td>
  </tr>
    <tr>
      <td>
      </td>
    </tr>
  </tbody>
  </table>
  </div>


    <PromoImages />

    <template v-if="showPredictionBlock">
<!--      A级大公开-->
      <FirstPredictionCard :sections="predictionSections" :game-label="predictionGameLabel" />
      <div class="page-wrapper">
        <img src="@/images/ydt.png"  alt="">
      </div>
<!--      三期必开-->
      <PredictionTable  id="sqbk" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="25"  :end="26"/>
      <PredictionTable   :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="26"  :end="27"/>
      <div class="page-wrapper">
        <img src="@/images/cs666.gif"  alt="">
      </div>
      <!--      高手榜-->
      <TitleList id="gsb" :items="predictionSectionList" :title="predictionGameLabel+  '高手榜'" :game="predictionGameCode"/>
      <div class="page-wrapper">
        <img src="@/images/smh.gif"  alt="">
        <img src="@/images/img-01.jpg"  alt="">
      </div>
<!--      十八码中特-->
      <PredictionTable  id="18mzt" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="1"  :end="2"/>
      <div class="page-wrapper">
        <img src="@/images/xxc.gif"  alt="">
        <img src="@/images/dys.gif"  alt="">
      </div>
<!--      平特三肖-->
      <ThreeTable id="ptsx"  :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="2"  :end="3"/>
      <div class="page-wrapper">
        <img src="@/images/pg251207.gif"  alt="">
        <img src="@/images/qp251207.gif"  alt="">
      </div>
<!--      无错八肖-->
      <ThreeTable id="wc8x" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="3"  :end="4"/>

      <!--澳門跑马图-->
      <DayImageCard v-if="pagePictureUrls[0]" id="ampm" :title="pagePictureUrls[0].desc" :urls="pagePictureUrls" :start="0" :end="1" :show-day-buttons="true" :show-year-cover="!predictionGameLabel.includes('港')" />



<!--      合数中特-->
      <ThreeTable id="hszt" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="4"  :end="5"/>
<!--      预言九肖-->
      <ThreeTable  id="yyjx" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="5"  :end="6"/>
      <DayImageCard v-if="pagePictureUrls[1]" :title="pagePictureUrls[1].desc" :urls="pagePictureUrls" :start="1" :end="2" :show-day-buttons="true" :show-year-cover="false"/>

<!--      琴棋书画-->
      <ThreeTable  id="qqsh" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="'琴：鸡-兔-蛇  |   棋：鼠-牛-狗\n书：马-龙-虎  |   画：羊-猴-猪'" :start="6"  :end="7"/>

<!--      30码-->
      <PredictionTable  id="30ma" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="7"  :end="8"/>
<!--      公式家野-->
      <ThreeTable id="gsjy" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="'家禽：牛-猪-鸡-狗-羊-马\n野兽：虎-鼠-猴-蛇-龙-兔'" :start="8"  :end="9"/>
      <!--第二张page图片-->
      <DayImageCard v-if="pagePictureUrls[2]" :title="pagePictureUrls[2].desc" :urls="pagePictureUrls" :start="2" :end="3" :show-day-buttons="true" :show-year-cover="false"/>
<!--      五肖16码-->
      <PredictionTable  id="wx16ma" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="9"  :end="10"/>
      <!--      五肖5码-->
      <PredictionTable id="5xtm" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="10"  :end="11"/>
      <div class="page-wrapper">
        <img src="@/images/2468hf4.jpg"  alt="">
        <img src="@/images/2468hf1.gif"  alt="">
      </div>
<!--      单双 两肖-->
      <ThreeTable  id="dslx" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="11"  :end="12"/>
<!--      平特一尾-->
      <ThreeTable id="ptyw" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="12"  :end="13"/>
<!--      必中一波-->
      <ThreeTable  id="bzyb" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="13"  :end="14"/>
<!--      曾道人图片-->
      <DayImageCard v-if="pagePictureUrls[3]"   :title="pagePictureUrls[3].desc" :urls="pagePictureUrls" :start="3" :end="4" :show-day-buttons="true" :show-year-cover="false"/>
      <!--      平特一肖-->
      <ThreeTable  id="ptyx" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="15"  :end="16"/>
      <!--      网络热图-->
      <StaggeredImages id="wlrt" :images="pictureUrls"  />
<!--      绝杀18码-->
      <PredictionTable  id="js18ma" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="16"  :end="17"/>
<!--      精五行-->
      <ThreeTable  id="jwx" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="'金：04,05,12,13,26,27,34,35,42,43\n木：08,09,16,17,24,25,38,39,46,47\n水：01,14,15,22,23,30,31,44,45\n火：02,03,10,11,18,19,32,33,40,41,48,49\n土：06,07,20,21,28,29,36,37'" :start="17"  :end="18"/>
<!--      灭庄14码-->
      <PredictionTable  id="mz14ma" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="18"  :end="19"/>
      <DayImageCard v-if="pagePictureUrls[4]"   :title="pagePictureUrls[4].desc" :urls="pagePictureUrls" :start="4" :end="5" :show-day-buttons="true" :show-year-cover="false"/>
<!--      绝杀3肖-->
      <ThreeTable id="jssx" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="19"  :end="20"/>
<!--      禁10码-->
      <ThreeTable  id="j10ma" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="predictionSectionDescList" :start="20"  :end="21"/>
<!--      吃肉吃菜-->
      <ThreeTable  id="crcc" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="'肉肖：虎-蛇-龙-狗\n菜肖：猪-鼠-鸡-猴\n草肖：牛-羊-马-兔'" :start="21"  :end="22"/>
<!--      吉美凶丑-->
      <ThreeTable  id="jmxc" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="'吉美：兔龙蛇马羊鸡\n凶丑：鼠牛虎猴狗猪'" :start="22"  :end="23"/>
<!--      阴阳肖-->
      <ThreeTable  id="yyx" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="'阳肖：牛-虎-兔-羊-猴-鸡\n阴肖：鼠-龙-蛇-马-狗-猪'" :start="23"  :end="24"/>
<!--      春夏秋冬-->
      <ThreeTable  id="cxqd" :sections="predictionSections" :game-label="predictionGameLabel" :section-descs="'春：兔虎龙\n夏：马蛇羊\n秋：鸡猴狗\n冬：鼠猪牛'" :start="24"  :end="25"/>
<!--      <ThreeTable  id="j10ma" :sections="predictionSections" :game-label="predictionGameLabel" :start="27"  :end="28"/>-->


    </template>


    <!-- <K14nfbPanel /> -->

 <!--   <PictureGallery
      v-if="pictureGalleryLotteryType != null"
      ref="pictureGallery"
      :lotteryType="pictureGalleryLotteryType"
      @open-preview="openPicturePreview"
    /> -->

    <!-- <video width="50%" height="100px" >

    </video> -->

    <!-- <video controls width="50%" height="160">
      <source src="http://video.suyuan1688.com/lottery/video/2026/2032/2026131.mp4" >
  
  您的浏览器不支持 HTML5 video 标签。
  </video> -->
    <!-- <LiveStream
      v-if="activeId === 'macau'"
      :streamUrl="displayLiveStreamUrl"
      :isHls="liveStreamIsHls"
    /> -->

<!--    <section v-for="panel in bbsVisible" :key="panel.file" class="bbs-panel" v-html="panel.html"></section>-->

<!--    <button type="button" class="fab-refresh" aria-label="回到顶部" @click="scrollToTop"><img src="/images/goTop.png" alt="顶部" class="fab-img" /></button>-->

    <PicturePreviewModal
      :preview="picturePreview"
      @close="closePicturePreview"
    />

    <OfficialNewsModal />

    <div class="bottom-imgs">
      <img src="@/images/tgie.jpg" alt="">
      <img src="@/images/sscg1.jpg" alt="">
      <img src="@/images/2020zh3.jpg" alt="">
    </div>
  
  
<!--  <iframe-->
<!--    v-if="iframeSrc"-->
<!--    ref="iframe"-->
<!--    class="mus55-iframe"-->
<!--    :src="iframeSrc"-->
<!--    frameborder="0"-->
<!--  ></iframe>-->
  
  </div>

</template>

<script>
import { fetchLatestDraw as requestLatestDraw, fetchDrawsPage } from '@/api/draw'
import { fetchLotteryTypesList } from '@/api/lotteryTypes'
import { fetchRecentPredictions, fetchPredictionSections } from '@/api/prediction'
import { fetchPictureList } from '@/api/pictures'
import { fetchZodiacMap } from '@/api/meta'
import { heroSlides, buildGames, makeGameFromBackend, waveTables, POST_DRAW_POLL_DEADLINE_GRACE_MS } from '@/config/gameConfig'
import { waveTone } from '@/utils/ballUtils'
import { mapApiToDraw, mapYuexiawangApiToDraw, mapHkLotteryApiToDraw, buildDrawFromOpenStyle, hasOpenStyleDataForFill, isOpenStyleResultComplete } from '@/services/apiAdapters'
import { mapRecordToRow } from '@/services/historyAdapters'
import { extractPagePayload } from '@/utils/httpUtils'
import http from '@/api/http'

import HeroCarousel from '@/components/lottery/HeroCarousel.vue'
import BallDisplay from '@/components/lottery/BallDisplay.vue'
// import PictureGallery from '@/components/lottery/PictureGallery.vue'
import PicturePreviewModal from '@/components/lottery/PicturePreviewModal.vue'
import PromoImages from '@/components/lottery/PromoImages.vue'
import NoticeBar from '@/components/lottery/NoticeBar.vue'
import PredictionTable from '@/components/lottery/PredictionTable.vue'
import FirstPredictionCard from '@/components/lottery/FirstPredictionCard.vue'
import ThreeTable from "@/components/lottery/ThreeTable.vue";
import StaggeredImages from "@/components/lottery/StaggeredImages.vue";
import DayImageCard from "@/components/lottery/DayImageCard.vue";
import TitleList from "@/components/lottery/TitleList.vue";
import OfficialNewsModal from "@/components/lottery/OfficialNewsModal.vue";
// import LiveStream from '@/components/lottery/LiveStream.vue'
// import K14nfbPanel from '@/components/lottery/K14nfbPanel.vue'

export default {
  name: 'HomePage',
  components: {
    DayImageCard,
    StaggeredImages,
    TitleList,
    ThreeTable, HeroCarousel, BallDisplay, PicturePreviewModal, PromoImages, NoticeBar, PredictionTable, FirstPredictionCard, OfficialNewsModal },
  data() {
    return {
      heroSlides,
      siteDomain: '',
      activeId: '',
      games: buildGames([]),
      backendGameIds: [],
      predictionSections: [],
      predictionSectionList: [],
      predictionSectionDescList: [],
      predictionGameLabel: '',
      predictionGameCode: '',
      pictureUrls: [],
      pagePictureUrls: [],
      drawLoadError: null,
      countdownText: '',
      countdownTimerId: null,
      drawPhaseNear: false,
      drawingChars: ['正','在','进','行','开','奖','中'],
      drawPollTimerId: null,
      drawPollGameId: null,
      drawPollBaseline: null,
      drawPollInFlight: false,
      drawPollAttempts: 0,
      pollSlotRevealed: null,
      zodiacMap: null,
      pictureGalleryLotteryType: null,
      picturePreview: null,
      previousDraws: {},
      bbsPanels: [],
      iframeSrc: '',
      randomPrefixes: ['123', 'abc'],
      randomPrefixTimerId: null,
    }
  },
  computed: {
    bbsVisible() { return this.bbsPanels.filter(p => p.html) },
    activeGame() { return this.games.find(g => g.id === this.activeId) || this.games[0] },
      bbsFiles() { return this.activeGame?.bbsFiles || [] },
    current() { return this.activeGame.draw },
    previousDraw() { return this.previousDraws[this.activeId] || null },
    displayDraw() { return this.showPreviousInstead && this.previousDraw ? this.previousDraw : this.current },
    revealedCount() {
      const d = this.current
      if (!d) return 0
      if (Array.isArray(d.revealed)) return d.revealed.filter(Boolean).length
      const mains = Array.isArray(d.mainNumbers) ? d.mainNumbers : []
      const mainCount = mains.filter(b => b && b.value != null && String(b.value).trim() !== '').length
      const sp = d.special && d.special.value != null && String(d.special.value).trim() !== '' ? 1 : 0
      return mainCount + sp
    },
    isFullyRevealed() { return this.revealedCount >= 7 },
    isLiveDrawing() { return this.revealedCount > 0 && !this.isFullyRevealed },
    effectiveDrawRevealed() {
      const d = this.displayDraw
      if (!d) return null
      if (Array.isArray(d.revealed)) return d.revealed
      const mains = Array.isArray(d.mainNumbers) ? d.mainNumbers : []
      const r = []
      for (let i = 0; i < 6; i++) {
        const b = mains[i]
        r.push(!!(b && b.value != null && String(b.value).trim() !== ''))
      }
      const sp = d.special
      r.push(!!(sp && sp.value != null && String(sp.value).trim() !== ''))
      return r
    },
    isInDrawingWindow() {
      const end = this.current && this.current.nextDrawDeadlineMs
      if (end == null || !Number.isFinite(end)) return false
      const off = end - Date.now()
      return off <= 3 * 60 * 1000 && off >= -15 * 60 * 1000
    },
    isDrawing() {
      return this.revealedCount === 0 && !this.isFullyRevealed && this.isInDrawingWindow
    },
    showPreviousInstead() {
      return !!(this.current && this.current.issue) &&
        this.revealedCount === 0 &&
        !this.isFullyRevealed &&
        !this.isDrawing &&
        !this.drawPhaseNear &&
        !!this.previousDraw
    },
    displayLiveStreamUrl() {
      const u = this.activeGame.liveStreamUrl
      return (u != null && String(u).trim() !== '') ? String(u).trim() : ''
    },
    liveStreamIsHls() { return this.displayLiveStreamUrl.toLowerCase().includes('.m3u8') },
    displayResultCardIssue() {
      if (this.showPreviousInstead && this.previousDraw) return this.previousDraw.issue
      const d = this.current
      if (!d) return ''
      const end = d.nextDrawDeadlineMs
      if (end == null || !Number.isFinite(end)) return d.issue
      const diff = end - Date.now()
      if (diff > 0 && diff <= 3 * 60 * 1000) {
        const nd = d.nextIssueDisplay
        if (nd != null && String(nd).trim() !== '' && nd !== '—') return nd
        const ni = d.nextIssue
        if (ni != null && String(ni).trim() !== '' && ni !== '—') return ni
      }
      // 数据全空 + 还未到 drawPhaseNear 窗口 → 沿用上期期号
      if (!this.drawPhaseNear && diff > 0 && this.revealedCount === 0 && this.previousDraw) {
        return this.previousDraw.issue
      }
      return d.issue
    },
    activePictureLotteryType() {
      return this.activeGame?.pictureLotteryType ?? null
    },
    nextDrawDateText() {
      const d = this.current
      if (!d || !d.nextDrawDeadlineMs) return ''
      const ms = d.nextDrawDeadlineMs
      const dt = new Date(ms)
      const g = this.activeGame || {}
      const hh = (d.drawHour != null ? String(d.drawHour) : g.drawHour != null ? String(g.drawHour) : String(dt.getHours())).padStart(2, '0')
      const mm = (d.drawMinute != null ? String(d.drawMinute) : g.drawMinute != null ? String(g.drawMinute) : String(dt.getMinutes())).padStart(2, '0')
      const wd = d.nextDayOfWeek ? '星期' + d.nextDayOfWeek : ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'][dt.getDay()]
      return `${dt.getMonth() + 1}月${dt.getDate()}日 ${wd} ${hh}:${mm}`
    },
    isBackendGameActive() {
      return this.backendGameIds.includes(this.activeId)
    },
    showPredictionBlock() {
      return this.isBackendGameActive ||
        this.predictionSectionList.length > 0 ||
        this.predictionSections.length > 0 ||
        this.pictureUrls.length > 0 ||
        this.pagePictureUrls.length > 0
    },
  },
  watch: {
    activeId() {
      this.closePicturePreview()
      this.clearPostDrawPoll()
      this.fetchBbsContent()
      this.initDraw()
      this.syncPictureGalleryTypeFromGame()
      if (this.isBackendGameActive) {
        this.predictionGameLabel = this.activeGame.label
        this.predictionGameCode = this.activeId
        this.loadPredictions()
        this.loadPictures()
        this.loadPredictionSections()
      }
    },
    current: { handler() { this.restartCountdownTimer() }, deep: true },
  },
  mounted() {
    this.activeId = this.games[0]?.id || ''
    fetchLotteryTypesList().then(res => {
      const list = res.data?.data?.list
      if (Array.isArray(list) && list.length > 0) {
        const existingIds = new Set(this.games.map(g => g.id))
        const newIds = []
        for (let i = list.length - 1; i >= 0; i--) {
          if (!existingIds.has(list[i].code)) {
            this.games.splice(1, 0, makeGameFromBackend(list[i]))
            newIds.push(list[i].code)
          }
        }
        this.activeId = this.games[1]?.id || this.games[0]?.id || ''
        this.backendGameIds = newIds
        newIds.forEach(id => {
          if (id !== this.activeId) this.fetchLatestDraw(id, { silent: true })
        })
      }
    }).catch(() => {})
    fetchZodiacMap().then(res => {
      if (res.data && res.data.code === 200 && res.data.data && res.data.data.map) {
        this.zodiacMap = res.data.data.map
      }
    }).catch(() => {})
    this.preloadOtherGames()
    const loadIframe = () => {
      this.iframeSrc = 'https://dxw-0529.www01490168c.com:2053/sx.htm'
    }
    if (document.readyState === 'complete') {
      setTimeout(loadIframe, 500)
    } else {
      window.addEventListener('load', () => setTimeout(loadIframe, 500))
    }
    this.randomPrefixTimerId = setInterval(() => {
      this.randomPrefixes = [this.randomDigits(), this.randomLetters()]
    }, 1500)
  },
  beforeDestroy() {
    this.clearCountdownTimer()
    this.clearPostDrawPoll()
    if (this.randomPrefixTimerId != null) { clearInterval(this.randomPrefixTimerId); this.randomPrefixTimerId = null }
  },
  methods: {
    randomDigits() {
      let s = ''
      for (let i = 0; i < 3; i++) s += Math.floor(Math.random() * 10)
      return s
    },
    randomLetters() {
      const chars = 'abcdefghijklmnopqrstuvwxyz'
      let s = ''
      for (let i = 0; i < 3; i++) s += chars.charAt(Math.floor(Math.random() * chars.length))
      return s
    },
    resolveDrawHttpRequest(game, options = {}) {
      const dr = game && game.drawRequest
      if (!dr || !dr.url) return null
      const afterDeadline = options.afterDeadline === true
      const resultUrl = (game.resultUrl && String(game.resultUrl).trim()) || ''
      let url, params
      if (afterDeadline && resultUrl) {
        url = resultUrl; params = { ...(dr.params || {}) }
      } else {
        url = dr.url; params = dr.params ? { ...dr.params } : {}
      }
      const isExternal = /^https?:\/\//i.test(url)
      return {
        url, method: dr.method || 'get', params, data: dr.data,
        headers: isExternal ? { Accept: '*/*' } : undefined
      }
    },

    async fetchLatestDraw(gameId, options = {}) {
      const silent = options.silent === true
      const afterDeadline = options.afterDeadline === true
      const id = gameId != null ? gameId : this.activeId
      const game = this.games.find(g => g.id === id)
      if (!game || !game.drawRequest || !game.drawRequest.url) return { ok: false }
      const httpReq = this.resolveDrawHttpRequest(game, { afterDeadline })
      if (!httpReq || !httpReq.url) return { ok: false }
      if (!silent) this.drawLoadError = null
      try {
        const res = await requestLatestDraw(httpReq)
        const data = res.data
        let payload = null
        if (Array.isArray(data)) { payload = data.length > 0 ? data[0] : null }
        else if (data && typeof data === 'object') {
          if (data.success === false || (data.code != null && Number(data.code) !== 200)) {
            throw new Error(data.msg || data.message || '接口返回失败')
          }
          if (data.data != null) {
            const inner = data.data
            payload = inner && typeof inner === 'object' && inner.data != null ? inner.data : inner
          } else { payload = data }
        }
        if (payload == null) {
          if (!silent) this.drawLoadError = '接口无数据'
          return { ok: false }
        }
        const schedule = game.drawSchedule || 'daily'

        if (Array.isArray(payload.body) && payload.body.length >= 9) {
          const draw = mapHkLotteryApiToDraw(payload, waveTables)
          if (!draw) {
            if (afterDeadline) return { ok: true, pollComplete: false }
            if (!silent) this.drawLoadError = '接口数据格式无法解析'
            return { ok: false }
          }
          if (this.zodiacMap) {
            const applyZodiac = (ball) => {
              if (!ball.value) return
              const key = String(parseInt(ball.value, 10))
              if (this.zodiacMap[key]) ball.zodiac = this.zodiacMap[key]
            }
            draw.mainNumbers.forEach(applyZodiac)
            applyZodiac(draw.special)
          }
          if (this.shouldSetDraw(id, draw)) this.$set(game, 'draw', draw)
          if (draw.revealed) {
            if (this.pollSlotRevealed == null) {
              this.pollSlotRevealed = [false,false,false,false,false,false,false]
            }
            for (let i = 0; i < 7; i++) {
              if (draw.revealed[i]) this.$set(this.pollSlotRevealed, i, true)
            }
          }
          const allRevealed = draw.revealed && draw.revealed.every(Boolean)
          return { ok: true, pollComplete: afterDeadline && allRevealed }
        }

        if (payload.k && typeof payload.k === 'string') {
          const draw = mapYuexiawangApiToDraw(payload, waveTables)
          if (!draw) {
            if (afterDeadline) return { ok: true, pollComplete: false }
            if (!silent) this.drawLoadError = '接口数据格式无法解析'
            return { ok: false }
          }
          // 应用生肖映射
          if (this.zodiacMap) {
            const applyZodiac = (ball) => {
              if (!ball.value) return
              const key = String(parseInt(ball.value, 10))
              if (this.zodiacMap[key]) ball.zodiac = this.zodiacMap[key]
            }
            draw.mainNumbers.forEach(applyZodiac)
            applyZodiac(draw.special)
          }
          if (this.shouldSetDraw(id, draw)) this.$set(game, 'draw', draw)
          if (draw.revealed) {
            if (this.pollSlotRevealed == null) {
              this.pollSlotRevealed = [false,false,false,false,false,false,false]
            }
            for (let i = 0; i < 7; i++) {
              if (draw.revealed[i]) this.$set(this.pollSlotRevealed, i, true)
            }
          }
          const allRevealed = draw.revealed && draw.revealed.every(Boolean)
          return { ok: true, pollComplete: afterDeadline && allRevealed }
        }

        const useOpenTimeAsDeadline = game.useOpenTimeAsDeadline === true
        const openStyleComplete = isOpenStyleResultComplete(payload)
        let draw = null
        if (hasOpenStyleDataForFill(payload) || useOpenTimeAsDeadline) {
          draw = buildDrawFromOpenStyle(payload, schedule, game.draw, waveTables, {
            afterDeadline,
            openStyleComplete,
            useOpenTimeAsDeadline
          })
        }
        if (!draw) { draw = mapApiToDraw(payload, schedule) }
        if (!draw) {
          if (!silent) this.drawLoadError = '接口数据格式无法解析'
          return { ok: false }
        }
        if (this.shouldSetDraw(id, draw)) this.$set(game, 'draw', draw)
        if (draw.revealed) {
          if (this.pollSlotRevealed == null) {
            this.pollSlotRevealed = [false,false,false,false,false,false,false]
          }
          for (let i = 0; i < 7; i++) {
            if (draw.revealed[i]) this.$set(this.pollSlotRevealed, i, true)
          }
        }
        return { ok: true, pollComplete: afterDeadline && openStyleComplete }
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.msg) || e.message || '请求失败'
        if (!silent) this.drawLoadError = msg
        return { ok: false }
      }
    },

    clearCountdownTimer() {
      if (this.countdownTimerId != null) { clearInterval(this.countdownTimerId); this.countdownTimerId = null }
    },
    restartCountdownTimer() {
      this.clearCountdownTimer()
      this.tickCountdown()
      this.countdownTimerId = setInterval(() => this.tickCountdown(), 1000)
    },
    tickCountdown() {
      const end = this.current && this.current.nextDrawDeadlineMs
      if (end == null || !Number.isFinite(end)) {
        this.countdownText = ''; this.drawPhaseNear = false
        if (this.drawPollTimerId == null) this.clearPostDrawPoll()
        return
      }
      const diff = end - Date.now()
      if (diff > 0) {
        if (this.drawPollTimerId == null) this.clearPostDrawPoll()
        this.drawPhaseNear = diff <= 5 * 60 * 1000
        if (diff <= 30000) {
          this.startPostDrawPollIfNeeded()
        }
        const sec = Math.floor(diff / 1000)
        const days = Math.floor(sec / 86400)
        const h = Math.floor((sec % 86400) / 3600)
        const m = Math.floor((sec % 3600) / 60)
        const s = sec % 60
        const pad = n => String(n).padStart(2, '0')
        this.countdownText = days > 0 ? `${days}天 ${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(h)}:${pad(m)}:${pad(s)}`
        return
      }
      this.countdownText = '00:00:00'; this.drawPhaseNear = false
      this.startPostDrawPollIfNeeded()
    },

    makeDrawBaselineSnapshot(draw) {
      if (!draw) return null
      const mains = (draw.mainNumbers || []).map(b => String(b.value ?? '')).join(',')
      const sp = draw.special ? String(draw.special.value ?? '') : ''
      return { issue: String(draw.issue || ''), sig: `${mains}|${sp}`, deadlineMs: draw.nextDrawDeadlineMs }
    },
    isDrawUpdatedSinceBaseline(baseline, draw) {
      if (!baseline || !draw) return false
      if (String(draw.issue || '') !== baseline.issue) return true
      const mains = (draw.mainNumbers || []).map(b => String(b.value ?? '')).join(',')
      const sp = draw.special ? String(draw.special.value ?? '') : ''
      if (`${mains}|${sp}` !== baseline.sig) return true
      const next = draw.nextDrawDeadlineMs
      if (next != null && Number.isFinite(next) && next > Date.now() + 1500) return true
      return false
    },
    clearPostDrawPoll() {
      if (this.drawPollTimerId != null) { clearInterval(this.drawPollTimerId); this.drawPollTimerId = null }
      this.drawPollGameId = null; this.drawPollBaseline = null
      this.drawPollInFlight = false; this.drawPollAttempts = 0; this.pollSlotRevealed = null
    },
    startPostDrawPollIfNeeded() {
      const game = this.activeGame
      if (!game || !game.drawRequest || !game.drawRequest.url) return
      if (this.drawPollTimerId != null) return
      this.drawPollGameId = this.activeId
      this.drawPollBaseline = this.makeDrawBaselineSnapshot(game.draw)
      this.drawPollAttempts = 0
      const pollUrl = (game.resultUrl && String(game.resultUrl).trim()) || ''
      const needsSlotBySlotReveal = /macaumarksix|^\/api\/live|\/yuexiawang/i.test(pollUrl)
      if (needsSlotBySlotReveal && !/yuexiawang/i.test(pollUrl)) {
        if (this.pollSlotRevealed == null) {
          this.pollSlotRevealed = [false,false,false,false,false,false,false]
        }
      } else if (this.pollSlotRevealed == null) {
        this.pollSlotRevealed = null
      }
      const maxAttempts = 400; const intervalMs = 1500
      const pollStopsOnlyOnOpenSeven = !!(game.resultUrl)
      const pollStopAfterMs = (() => {
        const d = this.drawPollBaseline && this.drawPollBaseline.deadlineMs
        if (d == null || !Number.isFinite(d)) return null
        return d + POST_DRAW_POLL_DEADLINE_GRACE_MS
      })()
      if (pollStopAfterMs != null && Date.now() > pollStopAfterMs) { this.clearPostDrawPoll(); return }
      const run = async () => {
        if (this.drawPollTimerId == null) return
        if (this.activeId !== this.drawPollGameId) { this.clearPostDrawPoll(); return }
        if (pollStopAfterMs != null && Date.now() > pollStopAfterMs) { this.clearPostDrawPoll(); return }
        if (this.drawPollAttempts >= maxAttempts) { this.clearPostDrawPoll(); return }
        if (this.drawPollInFlight) return
        this.drawPollInFlight = true; this.drawPollAttempts += 1
        let r = { ok: false }
        try { r = await this.fetchLatestDraw(this.activeId, { silent: true, afterDeadline: true }) }
        finally { this.drawPollInFlight = false }
        if (this.drawPollTimerId == null) return
        const g = this.activeGame
        if (r.pollComplete) { this.clearPostDrawPoll(); this.restartCountdownTimer(); return }
        if (!pollStopsOnlyOnOpenSeven && g && g.draw && this.drawPollBaseline &&
            this.isDrawUpdatedSinceBaseline(this.drawPollBaseline, g.draw)) {
          this.clearPostDrawPoll(); this.restartCountdownTimer()
        }
      }
      this.drawPollTimerId = setInterval(run, intervalMs); run()
    },

    ballTone(ball) {
      if (!ball) return 'blue'
      const t = ball.tone
      if (t === 'red' || t === 'blue' || t === 'green') return t
      return waveTone(ball.value, waveTables)
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onNavClick(e) {
      const a = e.target.closest('a')
      if (!a) return
      const href = a.getAttribute('href')
      if (!href || href.charAt(0) !== '#') return
      e.preventDefault()
      const el = document.getElementById(href.slice(1))
      if (!el) return
      const y = el.getBoundingClientRect().top + window.pageYOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    },
    onDomainLoaded(domain) {
      this.siteDomain = domain || ''
    },
    onRefresh() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.fetchLatestDraw()
      this.fetchBbsContent()
      this.$emit('refresh', { gameId: this.activeId })
    },
    async loadPredictionSections() {
      try {
        const site = process.env.VUE_APP_SITE_ID || 'default'
        const [listRes, descRes] = await Promise.all([
          fetchPredictionSections({ site, zoneType: 1 }),
          fetchPredictionSections({ site, zoneType: 0 })
        ])
        const listData = listRes.data
        this.predictionSectionList =
          listData.code === 200 && listData.data && Array.isArray(listData.data.sections)
            ? listData.data.sections
            : []
        const descData = descRes.data
        this.predictionSectionDescList =
          descData.code === 200 && descData.data && Array.isArray(descData.data.sections)
            ? descData.data.sections
            : []
      } catch (e) {
        this.predictionSectionList = []
        this.predictionSectionDescList = []
      }
    },
    async loadPredictions() {
      const id = this.activeId
      if (!id || !this.isBackendGameActive) {
        this.predictionSections = []
        return
      }
      try {
        const site = process.env.VUE_APP_SITE_ID || 'default'
        const res = await fetchRecentPredictions({ site, game: id })
        if (id !== this.activeId) return
        const data = res.data
        this.predictionSections =
          data.code === 200 && data.data && Array.isArray(data.data.sections)
            ? data.data.sections
            : []
        console.log(this.predictionSections[1])
      } catch (e) {
        this.predictionSections = []
      }
    },
    async loadPictures() {
      const game = this.activeGame
      const lotteryTypeId = game ? game.lotteryTypeId : null
      if (lotteryTypeId == null) {
        this.pictureUrls = []
        this.pagePictureUrls = []
        return
      }
      try {
        const [tukuRes, pageRes] = await Promise.all([
          fetchPictureList({ type: 'tuku', lotteryTypeId }),
          fetchPictureList({ type: 'page', lotteryTypeId })
        ])
        if (this.activeId !== game.id) return
        const tukuList =
          tukuRes.data && tukuRes.data.code === 200 && tukuRes.data.data && Array.isArray(tukuRes.data.data.list)
            ? tukuRes.data.data.list
            : []
        this.pictureUrls = tukuList
          .filter(it => it.fullUrl)
          .map(it => ({ src: it.fullUrl, desc: it.description }))
        const pageList =
          pageRes.data && pageRes.data.code === 200 && pageRes.data.data && Array.isArray(pageRes.data.data.list)
            ? pageRes.data.data.list
            : []
        this.pagePictureUrls = pageList
          .filter(it => it.fullUrl)
          .map(it => ({ src: it.fullUrl, desc: it.description }))
      } catch (e) {
        this.pictureUrls = []
        this.pagePictureUrls = []
      }
    },
    async fetchBbsContent() {
      if (this.bbsFiles.length === 0) return
      const id = this.activeGame.bbsId
      const results = await Promise.all(
        this.bbsFiles.map(async (file) => {
          try {
            const res = await http.get('/api/bbs-proxy', {
              params: { file, id },
              responseType: 'text'
            })
            return { file, html: typeof res === 'string' ? res : (res.data || '') }
          } catch (e) {
            return { file, html: '' }
          }
        })
      )
      this.bbsPanels = results.filter(p => p.html)
    },
    openPicturePreview(item) {
      if (!item) return
      const src = this.pictureFileUrl(item.localUrl)
      if (!src) return
      this.picturePreview = { src, title: item.pictureName ? String(item.pictureName) : '' }
    },
    closePicturePreview() { this.picturePreview = null },
    syncPictureGalleryTypeFromGame() {
      this.pictureGalleryLotteryType = this.activePictureLotteryType
    },
    async initDraw() {
      const gameId = this.activeId
      await this.fetchLatestDraw(gameId)
      await this.loadPreviousDraw(gameId)
      const rev = this.current && this.current.revealed
      if (Array.isArray(rev)) {
        const count = rev.filter(Boolean).length
        if (count > 0 && count < 7) {
          this.countdownText = '00:00:00'
          this.startPostDrawPollIfNeeded()
        }
      }
    },
    preloadOtherGames() {
      const others = this.games.filter(g => g.id !== this.activeId)
      others.forEach(g => {
        this.fetchLatestDraw(g.id, { silent: true })
      })
    },
    shouldSetDraw(id, draw) {
      if (draw && Array.isArray(draw.revealed) && draw.revealed.some(Boolean)) return true
      if (!this.previousDraws[id]) return true
      return false
    },
    async loadPreviousDraw(gameId) {
      const id = gameId != null ? gameId : this.activeId
      const game = this.games.find(g => g.id === id)
      if (!game || !game.drawPageType) return
      try {
        const res = await fetchDrawsPage({ type: game.drawPageType, page: 1, size: 1 })
        const payload = extractPagePayload(res)
        const rows = (payload && payload.list) || []
        if (rows.length) {
          const row = mapRecordToRow(rows[0], 0)
          if (row) {
            this.$set(this.previousDraws, id, row)
            // 只替换号码，保留 live 的倒计时字段
            const draw = game.draw
            if (draw && draw.revealed && !draw.revealed.some(Boolean)) {
              this.$set(draw, 'mainNumbers', row.mainNumbers)
              this.$set(draw, 'special', row.special)
            } else if (draw && !draw.revealed) {
              this.$set(draw, 'mainNumbers', row.mainNumbers)
              this.$set(draw, 'special', row.special)
            }
          }
        }
      } catch (e) { console.error('loadPreviousDraw失败', e) }
    },
    pictureFileUrl(localUrl) {
      if (localUrl == null || String(localUrl).trim() === '') return ''
      const path = String(localUrl).trim()
      if (/^https?:\/\//i.test(path)) return path
      const isDev = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development'
      if (isDev && path.startsWith('/')) return path
      const base = (typeof process !== 'undefined' && process.env && process.env.VUE_APP_API_BASE) || 'http://localhost:9999'
      const b = String(base).replace(/\/$/, '')
      return b + (path.startsWith('/') ? path : `/${path}`)
    }
  }
}
</script>

<style scoped>
.lottery-page {
  --bg-page: #f0f4f8; --text: #1a1a1a; --red: #e02020; --green: #2e7d32;
  --radius-card: clamp(0.5rem, 2vw, 0.75rem);
  width: 100%; max-width: min(30rem, 100%); margin-left: auto; margin-right: auto;
  min-height: 100vh; background: var(--bg-page); color: var(--text);
  //font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  position: relative;
  padding:
    clamp(0.25rem, 1vw, 0.4rem)
    max(clamp(0.25rem, 1vw, 0.4rem), env(safe-area-inset-right, 0px))
    max(3.25rem, env(safe-area-inset-bottom, 0px))
    max(clamp(0.25rem, 1vw, 0.4rem), env(safe-area-inset-left, 0px));
}
.hero-wrap { position: relative; container-type: inline-size; }
.page-wrapper img {
  display: block;
  width: 100%;
  height: auto;
}
.bottom-imgs img {
  display: block;
  width: 100%;
  height: auto;
}
.hero-domain {
  position: absolute; bottom: -2px; right: 10%;
  padding: 0.15rem clamp(0.5rem, 2.5vw, 0.75rem);
  padding: 0.15rem clamp(0.5rem, 2.5cqw, 0.75rem);
  border-radius: 999px;
  color: #ff0000;
  font-weight: 700; font-size: clamp(0.6rem, 5vw, 1rem);
  font-size: clamp(0.7rem, 3.5cqw, 1.1rem);
  white-space: nowrap;
  pointer-events: none;
  animation: hero-domain-flash 0.9s linear infinite;
}
@keyframes hero-domain-flash {
  0%, 49.9% { color: #ff0000; }
  50%, 100% { color: #000000; }
}
.game-tabs {
  display: flex;
  //gap: clamp(0.15rem, 1.5vw, 0.175rem);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; scrollbar-width: none;
  justify-content: flex-start; background: linear-gradient(180deg, #e8f3fc 0%, #dceaf8 100%);
  margin: 0;
  padding: 0;
  border-bottom: 1px solid rgba(94,176,255,0.4);
}
.game-tabs::-webkit-scrollbar { display: none; }
.game-tabs__btn {
  flex: 0 0 auto; min-width: auto; border: none;
  padding: clamp(0.5rem, 2.2vw, 0.625rem) clamp(0.625rem, 3vw, 0.75rem);
  font-size: clamp(0.75rem, 2.6vw, 0.8125rem); font-weight: 700; cursor: pointer;
  border-radius: 0; transition: background 0.2s, color 0.2s;
  background: rgba(21,58,107,0.08); color: #153a6b;
}
.game-tabs__btn.is-active { background: #ff8c00; color: #fff; }
.result-card {
  margin: clamp(0.5rem, 2.5vw, 0.625rem) 0 0; background: #fff;
  border: 0 solid #FF8C00FF;
  //border-radius: clamp(0.5rem, 2.5vw, 0.75rem);
  padding: 0;
  overflow: hidden; box-shadow: 0 4px 14px rgba(30,107,214,0.12);
  //font-family: KaiTi, STKaiti, '楷体', serif;
}
.result-card__content {
  padding: clamp(0.625rem, 3vw, 0.75rem) clamp(0.35rem, 1.8vw, 0.55rem) clamp(0.75rem, 3.2vw, 0.875rem);
}
.result-card__head {
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between;
  gap: clamp(0.375rem, 2vw, 0.5rem); margin-bottom: clamp(0.625rem, 3vw, 0.75rem);
}
.result-card__title { margin: 0; font-size: clamp(1rem, 4vw, 1.15rem); font-weight: 800; }
.result-card__links { font-size: clamp(0.85rem, 3.2vw, 0.9rem); }
.link-red { color: var(--red); text-decoration: none; font-weight: 700; }
.result-card__numbers-row {
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: clamp(0.25rem, 1.5vw, 0.5rem);
}
.result-card__next {
  margin: clamp(0.5rem, 2.5vw, 0.625rem) 0 0; font-size: clamp(0.85rem, 3.2vw, 0.9rem);
  font-weight: 700; color: #000000; text-align: left;
}
.result-card__title .countdown-num {
  display: inline-block; margin-left: 0.15em; font-variant-numeric: tabular-nums; letter-spacing: 0.03em;
}
.result_card_btn{
  color: #d58352;
  background: #0000ff;
  float: right;
  border: none;
  border-radius: 0.2rem;
  padding: 0.35rem 0.4rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(13, 13, 216, 0.35);
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}
.result_card_btn:active {
  transform: translateY(1px);
  box-shadow: 0 1px 3px rgba(13, 13, 216, 0.3);
}
.promo-green {
  margin: clamp(0.625rem, 3vw, 0.75rem) 2px 0;
  background: linear-gradient(90deg, #43a047, #66bb6a); color: #fff;
  padding: clamp(0.625rem, 3vw, 0.75rem) clamp(0.75rem, 3.5vw, 0.875rem);
  border-radius: var(--radius-card); font-size: clamp(0.75rem, 2.8vw, 0.8125rem);
  display: flex; flex-direction: column; gap: clamp(0.2rem, 1vw, 0.25rem); text-align: center;
}
.fab-refresh {
  position: fixed; right: clamp(0.75rem, 4vw, 1.25rem);
  bottom: max(3.5rem, env(safe-area-inset-bottom, 0px));
  width: clamp(2.25rem, 10vw, 2.5rem); height: clamp(2.25rem, 10vw, 2.5rem);
  border-radius: 50%; border: none; background: rgba(255,255,255,0.85);
  box-shadow: 0 2px 10px rgba(0,0,0,0.15); cursor: pointer;
  z-index: 999; padding: clamp(0.25rem, 1.2vw, 0.35rem);
  -webkit-tap-highlight-color: transparent; outline: none;
}
.fab-refresh:active { box-shadow: 0 2px 10px rgba(0,0,0,0.15); }
.fab-img { width: 100%; height: 100%; object-fit: contain; }
.bbs-panel {
  margin: clamp(0.5rem, 2.5vw, 0.625rem) 0 0;
  background: #fff;
  border: 2px solid #5eb0ff;
  border-radius: clamp(0.5rem, 2.5vw, 0.75rem);
  padding: clamp(0.5rem, 2.5vw, 0.625rem);
  overflow-x: auto;
  font-size: clamp(0.75rem, 2.8vw, 0.8125rem);
}
.bbs-panel :deep(table) {
  width: 100%;
  border-collapse: collapse;
}
.bbs-panel :deep(td) {
  padding: 0.3em 0.2em;
}
.bbs-panel :deep(.tit) {
  font-size: clamp(1.1rem, 4.5vw, 1.5625rem);
  background: linear-gradient(to right, #2196F3, #00BCD4);
  color: #faff00;
  text-align: center;
  line-height: 2.2;
  border-radius: 6px;
  font-weight: bold;
}
.bbs-panel :deep(#yjbt) {
  line-height: 2.2;
  font-size: clamp(1.05rem, 4vw, 1.3rem);
  padding: 0.4em 0;
  font-weight: 800;
  background: linear-gradient(90deg, #e02020, #ff6600, #ffcc00, #2ecc40, #0066ff, #8b00ff, #e02020);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: rainbow-flow 2s linear infinite;
}
@keyframes rainbow-flow {
  0% { background-position: 0% 50%; }
  100% { background-position: 200% 50%; }
}

.mus55-iframe {
  width: 100%;
  height: 94.375rem;
  border: none;
}


  
  .dkzlw {}
  .dkzlw th { color: #ff0; background: #f3a404;}
  .dkzlw td {}
  .webblack { color: #ff0; background: #000;}
  .webred { color: #ff0; background: #f00;}
  .webblue { color: #ff0; background: #00f;}
  .web1,.web2 { font-weight: bold; font-size: 24px; color: #f00;}
  .fontb { font-weight: bold;}
  /*表格*/
  .table1 {
    border: 2px solid #ff9900;
    border-collapse: collapse;
    margin-bottom: 0.3rem;
    margin-top: 0.3rem;
  }
  .table1 th,
  .table1 td { padding: 3px; text-align: center; border: solid 1px #ddd; font-size:18px}
  .table1.left td { text-align: left;}


  
.bbs-panel /deep/ .list-title {
    background: linear-gradient(transparent, #83430d);
    color: #ff0;
    text-shadow: 0px 0px 10px #f00;
    border-left: 1px solid #004400;
    border-right: 1px solid #55aaff;
    height: 40px;
    line-height: 40px;
    font-size: 24px;
    text-align: center;
    border-bottom: 1px solid #000;
    text-shadow: 1px 4px 1px rgba(0, 0, 0, .5);
    font-weight: bold;
    border-radius: 5px 5px 0 0;
}
.nav2 {
  background: #fff;
  padding: 0.4rem 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.nav2 ul {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.4rem;
  margin: 0;
  padding: 0;
  list-style: none;
}
.nav2 li {
  text-align: center;
}
.nav2 li a {
  display: inline-block;
  padding: 0.3rem 0.5rem;
  border-radius: 999px;
  background: #1e6bd6;
  color: #fff;
  font-size: 0.85rem;
  text-decoration: none;
  white-space: nowrap;
  max-width: 100%;
  box-sizing: border-box;
}
.nav2 li a:active {
  background: #1552a8;
  color: #fff;
}
</style>
